import { useEffect, useRef, useState } from 'react'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import OperativeApi from 'api/setting/treatments/operative.api'
import { routeName } from 'routes/routes-name'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import { resetModal, showModal } from 'app/slice/modal.slice'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError } from 'component/notifications/notifications'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getBranch, numberFormat, checkAddons } from 'utils/app.utils'
import { PACKAGE_ADDONS } from 'constants/package'
import { dateTimeToView } from 'utils/date.utils'
import { exportOperativeTypeToExcel } from './exportOperativeToExcel'
import ViweMore from './view-more'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function Operatives() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const branchCurrentId = getBranch()
  const componentRef = useRef<any>(null)
  const [operatives, setOperatives] = useState([])
  const [exportData, setExportData] = useState([])
  const [dataModal, setDataModal] = useState<{ isShow: boolean, type: "CLINIC_FEE" | "DIAGNOSES", data: any[] }>({ isShow: false, type: 'CLINIC_FEE', data: [] })
  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = async () => {
    try {
      let condition = {}
      condition = {
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      }
      const resp = await OperativeApi.findAll(condition)
      const respExport = await OperativeApi.findAll({ ...condition, export: 1 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setOperatives(resp.data)
        setExportData(respExport.data)
      } else {
        setOperatives([])
        setExportData([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const onCreate = () => {
    history.push(routeName.operatives + '/create')
  }

  const onActive = () => {
    if (id) {
      OperativeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onDelete = async () => {
    if (id) {
      OperativeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    history.push(routeName.operatives + '/update', data)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const viweMore = (type: 'CLINIC_FEE' | 'DIAGNOSES', data: any) => {
    setDataModal({ isShow: true, type, data })
    dispatch(showModal())
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'operativeType', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.OPERATIVE_TYPE'), class: 'text-nowrap' },
    { id: 'operativeCode', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.OPERATIVE_CODE'), class: 'text-nowrap' },
    { id: 'operativeName', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.OPERATIVE_NAME'), class: 'text-nowrap' },
    { id: 'operativeNameEn', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.OPERATIVE_NAME_EN'), class: 'text-nowrap' },
    { id: 'clinicFree', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.CLINIC_FEE'), class: 'text-nowrap', align: 'center' },
    { id: 'OPERATIVE', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.DIAGNOSIS'), class: 'text-nowrap', align: 'center' },
    { id: 'price', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.OPERATIVE_PRICE'), class: 'text-nowrap' },
    { id: 'status', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('OPERATIVE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' },
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { operativeId, operativeName, operativeNameEn, salePrice, operativeCode, operative_type, operativeClinicFees, operativeDiagnoses, updatedBy, updatedAt, status: optStatus } = objData
    const statusBtnActive = optStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = optStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const renderTextUnderline = (count: number, type: 'CLINIC_FEE' | 'DIAGNOSES', data: any) => count ? <a onClick={() => viweMore(type, data)}><u>{count}</u></a> : 0

    const newPrice = objData?.operativePrice?.length
      ? objData.operativePrice.some((item: any) => branchCurrentId === item.branchId)
        ? objData.operativePrice.find((item: any) => branchCurrentId === item.branchId)?.price
        : objData?.salePrice
      : null

    const objRenderData = {
      key: operativeId,
      id: operativeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        { option: 'TEXT', align: 'left', label: operative_type?.operativeTypeName || operative_type?.operativeTypeNameEn || '-' },
        { option: 'TEXT', align: 'left', label: operativeCode || '-' },
        { option: 'TEXT', align: 'left', label: operativeName || '-' },
        { option: 'TEXT', align: 'left', label: operativeNameEn || '-' },
        { option: 'COMPONENT', align: 'center', component: renderTextUnderline(operativeClinicFees.length, 'CLINIC_FEE', operativeClinicFees) },
        { option: 'COMPONENT', align: 'center', component: renderTextUnderline(operativeDiagnoses.length, 'DIAGNOSES', operativeDiagnoses) },
        {
          option: 'COMPONENT',
          align: 'right',
          component: (
            <div style={{ textAlign: 'right', lineHeight: '1.3' }}>
              <div style={{ whiteSpace: 'nowrap' }}>{objData?.branchPrice === '1' ? numberFormat(newPrice || 0) : numberFormat(salePrice || 0)}</div>
              {checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && (objData?.isPriceRange === '1' && objData?.maxSalePrice) && (
                <div style={{ fontSize: '11px', color: '#808080', whiteSpace: 'nowrap' }}>({numberFormat(objData.minSalePrice || 0)} - {numberFormat(objData.maxSalePrice)})</div>
              )}
            </div>
          )
        },
        { option: 'STATUS', align: 'center', label: optStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.operativeName)
    setNameEn(obj.operativeNameEn)
  }

  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`OPERATIVE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`OPERATIVE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { operativeName: name, operativeNameEn: nameEn && `(${nameEn})`, status: t(`OPERATIVE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('OPERATIVE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('OPERATIVE.SEARCH')}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('OPERATIVE.TITLE'),
                      statusFilter: filter[1].label,
                      rows: exportData.map((item: any) => ({
                        operativeTypeName: item?.operative_type?.operativeTypeName || '-',
                        operativeCode: item?.operativeCode || '-',
                        operativeName: item?.operativeName || '-',
                        operativeNameEn: item?.operativeNameEn || '-',
                        operativeClinicFees: item?.operativeClinicFees?.length || '0',
                        operativeDiagnoses: item?.operativeDiagnoses?.length || '0',
                        branchPrice: item?.branchPrice === '1' ?
                          item?.operativePrice?.length
                            ? item.operativePrice.some((item: any) => branchCurrentId === item.branchId)
                              ? item.operativePrice.find((item: any) => branchCurrentId === item.branchId)?.price
                              : item?.salePrice
                            : null
                          : numberFormat(item?.salePrice || 0),
                        status: t(`STATUS.${item?.status}`),
                        updatedBy: item?.updatedBy,
                        updatedAt: dateTimeToView(item?.updatedAt)
                      })),
                      t
                    }
                    exportOperativeTypeToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @media print {
                        @page { size: portrait }
                      }
                    `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                <MainButton title={t('OPERATIVE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => onCreate()} startIcon={<AddCircleIcon />} />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={operatives.map((val, i) => {
              return renderData(val, i, false)
            })}
          />
        </Box>
      </Box>
      {
        dataModal.isShow && <ViweMore {...dataModal} onReset={() => {
          dispatch(resetModal())
          setDataModal({ isShow: false, type: "CLINIC_FEE", data: [] })
        }} />
      }

      <Box
        id="print-table-container"
        ref={componentRef}
      >
        <Typography fontSize="14px" fontWeight={400}>{t('OPERATIVE.TITLE')}</Typography>
        <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
          <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {status === 'ALL' ? t('STATUS.ALL') : status === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
        </Box>
        <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
          <thead>
            <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
              <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE.TABLE.CELL.OPERATIVE_TYPE')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('OPERATIVE.TABLE.CELL.OPERATIVE_CODE')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE.TABLE.CELL.OPERATIVE_NAME')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE.TABLE.CELL.OPERATIVE_NAME_EN')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('OPERATIVE.TABLE.CELL.CLINIC_FEE')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('OPERATIVE.TABLE.CELL.DIAGNOSIS')}</th>
              <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('OPERATIVE.TABLE.CELL.OPERATIVE_PRICE')}</th>
              <th style={{ borderBottom: '1px solid black' }}>{t('OPERATIVE.TABLE.CELL.STATUS')}</th>
              <th style={{ borderBottom: '1px solid black' }}>{t('OPERATIVE.TABLE.CELL.UPDATED_BY')}</th>
            </tr>
          </thead>
          <tbody>
            {exportData?.length === 0 &&
              <tr>
                <td colSpan={10} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
              </tr>
            }
            {exportData?.map((data: any, index: number) => (
              <tr key={index}>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '30px' }}>{index + 1}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '85px' }}>{data?.operative_type?.operativeTypeName || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '85px' }}>{data?.operativeCode || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '120px' }}>{data?.operativeName || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '120px' }}>{data?.operativeNameEn || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{data?.operativeClinicFees?.length || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{data?.operativeDiagnoses?.length || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'center', width: '85px' }}>{data?.branchPrice === '1' ?
                  data?.operativePrice?.length
                    ? data.operativePrice.some((item: any) => branchCurrentId === item.branchId)
                      ? data.operativePrice.find((item: any) => branchCurrentId === item.branchId)?.price
                      : data?.salePrice
                    : null
                  : numberFormat(data?.salePrice || 0)}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <span>{data?.updatedBy || '-'}</span>
                  <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box >
  )
}
